import { CheckCircle2 } from "lucide-react";
import { Link, useLocation, useParams } from "react-router-dom";
import { useSitePath } from "../context/SiteContext";
import { ReservationSummary } from "../components/ReservationSummary";

export default function Confirmation() {
  const sp = useSitePath();
  const { ref } = useParams();
  const res = useLocation().state?.reservation;
  return (
    <div className="container-x max-w-4xl pt-16" data-testid="confirmation-page">
      <div className="animate-rise text-center">
        <CheckCircle2 className="mx-auto h-12 w-12 text-brand" strokeWidth={1.25} />
        <p className="eyebrow mt-6">Reservation confirmed</p>
        <h1 className="mt-2 font-serif text-5xl text-ink sm:text-6xl">We look forward to welcoming you</h1>
        <p className="mt-4 text-ink/60">Your reference is <span className="font-mono text-ink" data-testid="confirmation-ref">{ref}</span>. Keep it handy to find your reservation later.</p>
      </div>
      <div className="mt-10">
        {res ? <ReservationSummary res={res} /> : <p className="text-center text-ink/60">Use <Link to={sp("/find-reservation")} className="text-brand underline">Find Reservation</Link> to view the details.</p>}
      </div>
      <div className="mt-8 flex justify-center gap-3">
        <Link to={sp("/")} className="btn-outline" data-testid="confirmation-home-link">Back to home</Link>
        <Link to={sp("/find-reservation")} className="btn-primary" data-testid="confirmation-find-link">Find Reservation</Link>
      </div>
    </div>
  );
}
